import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import { FiAlertTriangle } from "react-icons/fi";
import SubscriptionExpiredModal from "../Common/SubscriptionExpireModal";

const SubscriptionContext = createContext();

export const SubscriptionProvider = ({ children }) => {
  const [subscriptionError, setSubscriptionError] = useState(null);
  const [modalDismissed, setModalDismissed] = useState(false);

  const showModal =
    subscriptionError?.data?.ExpireShow === true || subscriptionError?.data?.ExpireShow === "true";

  const dismissModal = () => setModalDismissed(true);

  const expireOn = subscriptionError?.data?.ExpireOn;

  const accessDeniedDate = expireOn
    ? (() => {
        const d = new Date(expireOn);
        d.setDate(d.getDate() + 7);
        return d.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
      })()
    : null;

  return (
    <SubscriptionContext.Provider value={{ subscriptionError, setSubscriptionError }}>
      {children}

      {showModal && !modalDismissed && (
        <SubscriptionExpiredModal onClose={dismissModal} type="expire" expireOn={expireOn} />
      )}

      {/* Scrolling ticker banner — fixed at the bottom of the screen. Stays visible
          the whole session while ExpireShow is true, independent of the modal being dismissed. */}
      {showModal && (
        <>
          <style>{`
            @keyframes subscriptionTicker {
              0%   { transform: translateX(100%); }
              100% { transform: translateX(-100%); }
            }
            .subscription-ticker-inner {
              display: inline-flex;
              align-items: center;
              white-space: nowrap;
              animation: subscriptionTicker 32s linear infinite;
            }
            .subscription-ticker-sep {
              display: inline-block;
              margin: 0 28px;
              opacity: 0.5;
            }
          `}</style>
          <div
            role="alert"
            aria-live="polite"
            style={{
              position: "fixed",
              bottom: 0,
              left: 0,
              width: "100%",
              zIndex: 99999,
              background: "linear-gradient(90deg, #b02a1f 0%, #d9483a 100%)",
              color: "#fff",
              padding: "6px 0",
              fontSize: "12.5px",
              fontWeight: 500,
              letterSpacing: "0.2px",
              fontFamily: "inherit",
              boxShadow: "0 -2px 8px rgba(0,0,0,0.25)",
              overflow: "hidden",
              borderTop: "1px solid rgba(255,255,255,0.25)",
            }}
          >
            <span className="subscription-ticker-inner">
              {[0, 1].map((i) => (
                <span key={i} style={{ display: "inline-flex", alignItems: "center" }}>
                  <FiAlertTriangle size={14} style={{ marginRight: "8px", flexShrink: 0 }} />
                  <span>
                    Your subscription has expired.
                    {accessDeniedDate && (
                      <>
                        {" "}
                        Access will be blocked after <strong>{accessDeniedDate}</strong>.
                      </>
                    )}{" "}
                    Kindly renew at the earliest.
                  </span>
                  <span className="subscription-ticker-sep">•</span>
                </span>
              ))}
            </span>
          </div>
        </>
      )}
    </SubscriptionContext.Provider>
  );
};
export const useSubscription = () => useContext(SubscriptionContext);

SubscriptionProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
